<script setup lang="ts">
import MarkdownIt from 'markdown-it';

const props = defineProps<{
  rules: string | null;
}>();

const md = new MarkdownIt({ html: false, linkify: true, breaks: true });

const renderedRules = computed(() =>
  props.rules ? md.render(props.rules) : '',
);
</script>

<template>
  <div class="event-rules-section mb-6">
    <template v-if="rules">
      <h2 class="text-h6 mb-3">Event rules</h2>
      <!-- eslint-disable vue/no-v-html — markdown-it with html:false; no raw user HTML rendered -->
      <div
        class="event-rules-content text-body-1 mb-4"
        v-html="renderedRules"
      />
      <!-- eslint-enable vue/no-v-html -->
    </template>

    <v-divider class="mb-4" />

    <div class="text-body-2 text-medium-emphasis">
      <p>
        This event is organized by the event host, not by Arvee. By
        participating, you agree to follow the organizer's rules and Arvee's
        community guidelines.
      </p>
    </div>
  </div>
</template>

<style scoped>
.event-rules-content :deep(h1),
.event-rules-content :deep(h2),
.event-rules-content :deep(h3) {
  margin-top: 0.75em;
  margin-bottom: 0.5em;
  font-weight: 600;
}

.event-rules-content :deep(ul),
.event-rules-content :deep(ol) {
  padding-left: 1.5em;
  margin-bottom: 0.75em;
}

.event-rules-content :deep(p) {
  margin-bottom: 0.5em;
}

.event-rules-content :deep(a) {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}

.event-rules-content :deep(code) {
  background: rgba(var(--v-theme-on-surface), 0.08);
  padding: 0.15em 0.4em;
  border-radius: 4px;
  font-size: 0.9em;
}

.event-rules-content :deep(blockquote) {
  border-left: 3px solid rgba(var(--v-theme-on-surface), 0.2);
  padding-left: 1em;
  margin-left: 0;
  margin-bottom: 0.75em;
  color: rgba(var(--v-theme-on-surface), 0.7);
}
</style>
